import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import Card from './Card';
import { ItemTypes } from './ItemTypes';
import update from 'immutability-helper';

const style = {
    width: '92%'
};

const FormulaBuilder = (props) => {
    const moveCard = (id, atIndex) => {
        const { card, index } = findCard(id);
        props.setFormulaItems(
            update(props.formulaItems, {
                $splice: [
                    [index, 1],
                    [atIndex, 0, card]
                ]
            })
        );
    };
    const findCard = (id) => {
        const card = props.formulaItems.filter((c) => `${c.id}` === id)[0];
        return {
            card,
            index: props.formulaItems.indexOf(card)
        };
    };
    const [, drop] = useDrop({ accept: ItemTypes.CARD });
    // console.log(props.formulaItems);
    return (
        <>
            <div ref={drop} style={style} className="formula-builder-box">
                {props.formulaItems.map((card) => (
                    <Card
                        key={card.id}
                        id={`${card.id}`}
                        text={card.text}
                        className={card.class_name}
                        moveCard={moveCard}
                        findCard={findCard}
                    />
                ))}
            </div>
        </>
    );
};

export default FormulaBuilder;
